<template>
  <div class="container clinic-dots">
    <b-modal :title="dot.id ? 'Editar DOT' : 'Crear DOT'" ref="dotmodal" hide-footer id="clinic-show-dot"
      class="clinic-show-dot">

      <div class="form-group row">
        <div class="col-sm-6">
          <select v-model="dot.block" class="custom-select" id="dot_edit_block">
            <option :value="null">Todos</option>
            <option value="diagnostic">Diagnóstico</option>
            <option value="objectives">Objetivos</option>
            <option value="treatment">Tratamientos</option>
          </select>
          <label for="dot_edit_block" class="wabident-info">Bloque</label>
        </div>
        <div class="col-sm-6">
          <input type="text" class="form-control" v-model="dot.group" id="dot_edit_group">
          <label for="dot_edit_block" class="wabident-info">Grupo</label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12">
          <input type="text" class="form-control" v-model="dot.content" id="dot_edit_content">
          <label for="dot_edit_content" class="wabident-info">Contenido</label>
        </div>
      </div>

      <div class="form-group row mt-3">
        <div class="col text-center">
          <button v-if="dot.id" @click="deleteDOT" class="btn btn-wabident red mx-3">
            Borrar
          </button>
          <button @click="closeDialog" class="btn btn-wabident mx-3">
            Cancelar
          </button>
          <button @click="saveDOT" :disabled="!validateDOT()" class="btn btn-wabident mx-3">
            Guardar
          </button>
        </div>
      </div>

    </b-modal>
    <div class="row mb-3">
      <div class="col-sm-12 mb-3">
        <button class="btn btn-wabident-round float-right" @click="createDOT()"><i class="fas fa-plus"></i>
          Crear</button>
        <h1 class="page-title">TIPOS DOT</h1>
      </div>
      <div class="col-sm-4">
        <select v-model="block" class="custom-select" id="dot_block">
          <option :value="null">Todos</option>
          <option value="diagnostic">Diagnóstico</option>
          <option value="objectives">Objetivos</option>
          <option value="treatment">Tratamientos</option>
        </select>
        <label for="dot_block" class="wabident-info">Bloque</label>
      </div>
      <div class="col-sm-4">
        <input v-model="group" class="form-control icon" type="search" id="template_group_search"
          placeholder="Grupo ..." />
        <label for="template_group_search" class="wabident-info">Grupo</label>
      </div>
      <div class="col-sm-4">
        <input v-model="search" class="form-control icon" type="search" id="template_group_content"
          placeholder="Contenido ..." />
        <label for="template_group_content" class="wabident-info">Contenido</label>
      </div>
    </div>
    <div v-if="results && !is_searching" class="row">
      <div class="col-sm-12">
        <table class="table table-search-results">
          <thead>
            <tr>
              <th>ORDEN</th>
              <th>BLOQUE</th>
              <th>GRUPO</th>
              <th>CONTENIDO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dot in results.data" class="table-search-results__row" @click="changeDOT(dot)">
              <td>{{ dot.order }}</td>
              <td>{{ pretty_blocks[dot.block] }}</td>
              <td>{{ dot.group }}</td>
              <td>{{ dot.content }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-12">
        <data-pagination :page="page" :total="total" @gotopage="changePage"></data-pagination>
      </div>
    </div>
    <div v-else class="row">
      <div class="col text-center">
        <h3>Buscando <i class="fas fa-spinner fa-spin"></i></h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pretty_blocks: {
        'diagnostic': 'Diagnóstico',
        'objectives': 'Objetivos',
        'treatment': 'Tratamiento',
      },
      block: null,
      group: null,
      search: null,
      results: null,
      page: 1,
      is_searching: false,
      dot: {
        id: null,
        block: null,
        group: null,
        content: null,
      }
    }
  },
  computed: {
    total() {
      if (!this.results) return 0;
      return this.results.total ? this.results.last_page : 0;
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  watch: {
    block() {
      this.reset();
    },
    group() {
      this.reset();
    },
    search() {
      this.reset();
    }
  },
  methods: {
    validateDOT() {
      return this.dot.block &&
        this.dot.group &&
        this.dot.group !== '' &&
        this.dot.content &&
        this.dot.content !== '';
    },
    saveDOT() {
      if (this.is_searching) return;
      this.is_searching = true;

      const params = {
        id: this.dot.id,
        block: this.dot.block,
        group: this.dot.group,
        content: this.dot.content,
      };

      axios.post(`/clinic/${this.clinic.id}/dots`, params).then((response) => {
        this.msgwindow.success('DOT Guardado');
      }).catch((err) => {
        this.msgwindow.error('Error guardando DOT !');
      }).then(() => {
        this.is_searching = false;
        this.$refs.dotmodal.hide();
        this.reset();
      });
    },
    closeDialog() {
      this.$refs.dotmodal.hide();
    },
    deleteDOT() {
      if (this.is_searching) return;

      this.errorwindow.show('Confirmación', 'Esta operación no se puede deshacer. ¿Estás seguro/a?', 'Borrar', 'Cancelar', () => {
        this.is_searching = true;

        axios.post(`/clinic/${this.clinic.id}/dots/${this.dot.id}`, { '_method': 'delete' }).then((r) => {
          this.msgwindow.success('DOT Borrado');
        }).catch((err) => {
          this.msgwindow.error('Error borrando DOT !');
        }).then(() => {
          this.is_searching = false;
          this.$refs.dotmodal.hide();
          this.reset();
        });
      });
    },
    createDOT() {
      this.dot.id = null;
      this.dot.block = 'diagnostic';
      this.dot.group = null;
      this.dot.content = null;
      this.$refs.dotmodal.show();
    },
    changeDOT(dot) {
      this.dot.id = dot.id;
      this.dot.block = dot.block;
      this.dot.group = dot.group;
      this.dot.content = dot.content;
      this.$refs.dotmodal.show();
    },
    changePage(page) {
      this.page = page;
      this.searchDOTs();
    },
    searchDOTs() {
      if (this.is_searching) return;
      this.is_searching = true;

      const params = {
        block: this.block,
        group: this.group,
        search: this.search,
        page: this.page,
      };

      axios.get(`/clinic/${this.clinic.id}/dots`, { params }).then((response) => {
        this.results = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error buscando DOTs');
      }).then(() => {
        this.is_searching = false;
      });
    },
    reset() {
      this.page = 1;
      this.searchDOTs();
    }
  },
  mounted() {
    this.searchDOTs();
  }
}
</script>

<style lang="scss">
.clinic-dots {
  margin-top: 30px;
}
</style>
